import loggingService from '../util/loggingService'

var serviceName = 'historicalRegisterStatusService'
var path = '/HistoricalRegisterStatusInstance/'
var isDebug = false

function put (http, historicalRegisterStatusDto) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path, historicalRegisterStatusDto)
}

function get (http, id) {
    loggingService.log(isDebug, serviceName, 'get')
    return http.get(path + 'Get?historicalRegisterStatusInstanceId=' + id)
}

function search (http, searchObject) {
    loggingService.log(isDebug, serviceName, 'Searching by ' + searchObject.culturalResourceRecordingId)
    return http.post(path + 'Search', searchObject)
}

export default {
    put: put,
    get: get,
    search: search
}



// WEBPACK FOOTER //
// ./src/services/siteForm/HistoricalRegisterStatusService.js